<template>
  <div class="campaign-event-info">
    <div class="campaign-event-info--title d-flex align-items-center justify-content-between gap-2">
      <h5>{{ event.event_name }}</h5>
      <span :class="`convo-${statusType} badge font-weight-medium`">{{ status }}</span>
    </div>
    <hr>
    <div class="campaign-event-info--content d-flex flex-column">
      <div class="campaign-event-info--content-item">
        <span>Start Time:</span>
        <span>{{ startTime }}</span>
      </div>
      <div class="campaign-event-info--content-item">
        <span>Elapsed Time:</span>
        <span>{{ elapsedTime }}</span>
      </div>
      <div class="campaign-event-info--content-item">
        <span>Total Subscribers:</span>
        <span>{{ formatNumber(event.total_subscribers) }}</span>
      </div>
      <div class="campaign-event-info--content-item">
        <span>Event Message:</span>
        <span>{{ event.event_message }}</span>
      </div>
      <template v-if="statusType === 'archived'">
        <button
          type="button"
          class="btn btn-rounded btn-block btn-secondary"
          @click="archiveCampaign(event.event_id, event.campaign_id)"
        >
          Archive Event
        </button>
      </template>
      
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import moment from "moment";
import { mapGetters } from "vuex";
import formatter from "@/mixins/formatter";
import { formatDuration } from '../../util';
export default {
  name: "CampaignEventInfo",
  mixins: [formatter],
  props: {
    event: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters("user", ["currentToken"]),
    ...mapGetters("agency", ["currentAgency"]),
    ...mapGetters("campaigns", ["currentCampaignEvents"]),
    status() {
      if (this.event.event_status) {
        return this.event.event_status.charAt(0).toUpperCase() + this.event.event_status.slice(1);
      }
      return "Pending";
    },
    statusType() {
      return (this.event.event_status || "").toLowerCase() !== "delivered"
        ? "active"
        : "archived";
    },
    startTime() {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      return moment.utc(this.event.created_at).tz(tz).format("MMM D, YYYY h:mm a");
    },
    elapsedTime() {
      const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const startTime = moment.utc(this.event.created_at).tz(tz).valueOf();
      const endTime = moment().valueOf();
      return formatDuration((endTime - startTime) / 1000);
    }
  },
  methods:{
    async archiveCampaign(eventId, campaignId){
      try {
        const payload = {
          "event_status": "archived"
        };
        await this.$ConveyApi.campaignsApi.updateCampaignEvent({ campaignId, eventId, payload });
        this.$toastr("success", "Campaign Event Archived.");
        const currentEvents = [...this.currentCampaignEvents];
        const archivedEventIndex = currentEvents.findIndex(event => event.event_id === eventId);
        currentEvents.splice(archivedEventIndex, 1);
        this.$store.commit("campaigns/setCurrentCampaignEvents", currentEvents);
        this.$router.push({ path: `/campaigns/${campaignId}` }).catch(() => {});
      } catch(err) {
        console.log("[archiveCampaign] ERROR: ", err);
        this.$toastr("error", "Error occurred archiving campaign event. Please try again.");
      } finally {}
    }
  }
};
</script>

<style lang="scss">
.campaign-event-info {
  &--title {
    gap: .5rem;

    h5 {
      margin: 0;
      flex: 1;
      word-break: break-all;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  &--content {
    gap: .5rem;
    &-item {
      display: flex;
      align-items: flex-start;
      >span {
        &:first-child {
          flex: 1 1 50%;
          font-weight: bold;
          white-space: nowrap;
        }
        &:last-child {
          flex: 1 1 50%;
          overflow: hidden;
          text-overflow: ellipsis;
          word-break: break-all;;
        }
      }
    }
  }
}
</style>
